import { render, staticRenderFns } from "./OverlayComponent.vue?vue&type=template&id=4e096a23&"
import script from "./OverlayComponent.vue?vue&type=script&lang=js&"
export * from "./OverlayComponent.vue?vue&type=script&lang=js&"
import style0 from "./OverlayComponent.vue?vue&type=style&index=0&id=4e096a23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports